import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerRegistroCorrispettiviIvaModalComponent } from './worker-registro-corrispettivi-iva-modal';

export const WorkerRegistroCorrispettiviIvaModalModule: string = ng
    .module('worker-registro-corrispettivi-iva-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerRegistroCorrispettiviIvaModalComponent', WorkerRegistroCorrispettiviIvaModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-registro-corrispettivi-iva-modal/worker-registro-corrispettivi-iva-modal.module.ts